// Script for returning visitors to the appropriate spot on the employee overview after viewing individual employees on /om-os/medarbejdere/

// Detect if browser is IE or Edge
if (navigator.appName == 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) || (typeof $.browser !== "undefined" && $.browser.msie == 1) || navigator.userAgent.indexOf("Edge") > -1) {
    var originalScrollPositionY;
    // Check if correct url
    if (document.querySelector(".employee-overview")) {
        // If the correct url is present, then navigate to the previously stored originalScrollPositionY in localStorage
        window.onload = function () {
            // Has to be set in a timeout, otherwise it's unreliable in IE and Edge
            if (localStorage.getItem("scrollPosition") != undefined) {
                setTimeout(function () {
                    window.scrollTo(0, localStorage.getItem("scrollPosition"));
                }, 1200);
            }
        }
        window.onunload = function () {
            // Use pageYOffset for cross-browser compatability
            originalScrollPositionY = window.pageYOffset;
            // Add the new position to localstorage
            localStorage.setItem("scrollPosition", originalScrollPositionY);
        }
    }
}